import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import {
  Drawer,
  TextLink,
  ToastProvider,
  useToast,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, useCallback, useState } from 'react';
import { DetailDrawerContainer } from './DetailDrawerContainer';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  apPayeeId: string;
  apPayeeName: string;
};

export type DetailDrawerProps = {
  open: boolean;
  onClose: () => void;
  apPayeeId: string;
};

const DetailDrawer: FC<DetailDrawerProps> = ({ open, onClose, apPayeeId }) => {
  const DEFAULT_DRAWER_DETAIL_WIDTH = 1000;
  const containerRef = useGlobalContainerRef();
  const { t } = useTranslation();

  return (
    <Drawer
      className={cx(styles['detailDrawerContainer'])}
      width={DEFAULT_DRAWER_DETAIL_WIDTH}
      visible={open}
      onClose={onClose}
      destroyOnClose
      title={<div>{t('ap_payee_detail_title')}</div>}
      getContainer={containerRef}
      mask
    >
      <DetailDrawerContainer apPayeeId={apPayeeId} onClose={onClose} />
    </Drawer>
  );
};

export const PayeeDetailDrawer: FC<Props> = ({ apPayeeId, apPayeeName }) => {
  const [toastApi, toastContextHolder] = useToast();
  const [open, setOpen] = useState(false);
  const onOpen = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setOpen(true);
  }, []);
  const onClose = useCallback(() => {
    setOpen(false);
  }, []);
  return (
    <ToastProvider value={toastApi} contextHolder={toastContextHolder}>
      <TextLink onClick={onOpen} href='#'>
        {apPayeeName}
      </TextLink>
      {open && (
        <DetailDrawer open={open} apPayeeId={apPayeeId} onClose={onClose} />
      )}
    </ToastProvider>
  );
};

PayeeDetailDrawer.displayName = 'PayeeDetailDrawer';
